/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { CostCenter, EntitiesModel, PaginationModel } from '@lm-nx-frontend/lm-inf-core';
import { TableService } from '@lm-nx-frontend/lm-inf-ui';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationTableType } from '../../shared/organization.model';
import { SubListService } from '../../shared/sub-list/sub-list.service';
import {BudgetService} from "../../../core/services";
import {Budget} from "../../../core/model";

@Injectable({
  providedIn: 'root',
})
export class BudgetCostCenterListService extends SubListService<Budget> {
  protected tableType = OrganizationTableType.BUDGET_ASSIGNED_COST_CENTERS;
  protected _domainType = OrganizationTableType.COST_CENTER;

  constructor(
    protected tableService: TableService,
    protected budgetService: BudgetService
  ) {
    super(tableService);
  }

  protected load(
    _pagination: PaginationModel,
    code: string
  ): Observable<EntitiesModel<CostCenter>> {
    return this.budgetService.getCostCenters(code).pipe(
      filter((list) => Boolean(list)),
      map((costCenter) => this.filterSelected(costCenter))
    );
  }

  /**
   * As we can't filter with the backend API, we do this client side.
   */
  protected filterSelected({
    pagination,
    sorts,
    values,
  }: EntitiesModel<CostCenter>): EntitiesModel<CostCenter> {
    return {
      pagination,
      sorts,
      values: values.filter((value) => value.active),
    };
  }
}
